import React, { useEffect, useState } from 'react';
import './blog.css';
import marked from 'marked';

export default function BlogContent(props) {
  const [blogHtml, setBlogHtml] = useState('');
  useEffect(function() {
    let bpath = props.blogPath;
    fetch(
      'https://raw.githubusercontent.com/akulsr0/website-blogs/master/' +
        bpath +
        '.md'
    )
      .then(response => {
        return response.text();
      })
      .then(text => setBlogHtml(marked(text)));

    document.getElementById('blogContent').innerHTML = blogHtml;
  });
  return (
    <div>
      <br />
      <div id='blogContent'></div>
    </div>
  );
}
